import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsAutomationCRoute: InvariantJiraRoute = {
	name: 'project-settings-automation',
	path: '/jira/software/c/projects/:projectKey/settings/automate',
};
